const showPopup = (show: Ref<boolean>) => {
  show.value = true

  // stop scrolling
  const body = document.getElementsByTagName('body')[0]
  console.log(body)
  body.classList.add('disable-scroll')
}

const closePopup = (show: Ref<boolean>) => {
  show.value = false

  // enable scrolling
  const body = document.getElementsByTagName('body')[0]
  body.classList.remove('disable-scroll')
}

type usePopupReturnType = {
  showPopup: typeof showPopup
  closePopup: typeof closePopup
}

export function usePopup(): usePopupReturnType {
  return {
    showPopup,
    closePopup
  }
}
